import {
  getMemberInfo
} from '@/api/member' // 导入资金信息相关接口

const member = {
  state: {
    addMemberDialog: {
      title: '新增会员信息',
      type: 'add'
    },
    memberSearch: {
      telephoneNumber: '',
      name: '',
      memberStatus: ''
    },
    memberSearchBtnDisabled: true
  },
  getters: {
    addMemberDialog: state => state.addMemberDialog,
    memberSearch: state => state.memberSearch,
    memberSearchBtnDisabled: state => state.memberSearchBtnDisabled,
  },
  mutations: {
    SET_MEMBER_DIALOG_TITLE: (state, type) => {
      if (type === 'add') {
        state.addMemberDialog.title = '新增会员信息'
        state.addMemberDialog.type = 'add'
      } else {
        state.addMemberDialog.title = '编辑会员信息'
        state.addMemberDialog.type = 'edit'
      }
    },
    SET_MEMBER_SEARCH: (state, payload) => {
      // console.log(payload);
      state.memberSearch = payload;
    },
    SET_MEMBER_SEARCHBTN_DISABLED: (state, payload) => {
      state.memberSearchBtnDisabled = payload;
    }
  },
  actions: {
    // 获取会员列表
    GetMemberList({
      commit
    }, reqData) {
      return new Promise(resolve => {
        getMemberInfo(reqData).then(response => {
          const data = response.data
          resolve(data)
        })
      })
    }


  }
}

export default member